module.exports = __webpack_public_path__ + "static/media/anna_flower.94036071.png";